module.exports = __webpack_public_path__ + "img/512.0df64525.png";